import React, { Component, Fragment } from 'react';
import ReportShow from '../show';
import Filter from "./filter";
import Presenter from "./presenter";

export default class Show extends Component {
  render() {
    return (
      <ReportShow
        title='Bookings report'
        path='/admin/reports/bookings'
        filter={<Filter/>}
        presenter={<Presenter/>}
      />
    );
  }
}


